import Icon from '../components/Icon.vue';
Icon.register({
  'clinic-medical': {
    width: 576,
    height: 512,
    paths: [{
      d: 'M288 115l218.7 192.9c1.5 1.4 3.6 2 5.3 3.2v184.9c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-184.9c1.8-1.2 3.8-1.9 5.5-3.3zM384 376v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8zM570.7 236.3c3.3 2.9 5.3 7.2 5.3 11.9 0 4.1-1.5 7.8-4.1 10.7l-21.4 23.8c-2.9 3.3-7.2 5.3-11.9 5.3-4.1 0-7.9-1.6-10.7-4.1l-229.3-202.3c-2.8-2.5-6.5-4-10.6-4-4.1 0-7.8 1.5-10.6 4l-229.3 202.3c-2.8 2.5-6.6 4.1-10.7 4.1-4.7 0-9-2.1-11.9-5.3l-21.4-23.8c-2.5-2.8-4.1-6.6-4.1-10.7 0-4.7 2.1-9 5.3-11.9l256-226c7.1-6.4 16.5-10.3 26.7-10.3 10.3 0 19.6 3.9 26.7 10.3z'
    }]
  }
});